import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-angle-left-icon',
  templateUrl: './navigation-angle-left.component.html'
})
export class NavigationAngleLeftComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
